const employeeContent = {
  title: '직원 관리 매뉴얼',
  content: `
  <div class="page-title">[직원 관리]</div>

# [개요]
직원 관리는 관리자 시스템을 사용하는 직원 계정을 관리하기 위한 도구입니다. 이 문서에서는 **직원 계정의 등록, 수정, 조회 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 직원 조회 | 등록된 직원 목록 확인 및 검색 | 관리자 |
| 직원 등록 | 신규 직원 계정 등록 | 관리자 |
| 직원 수정 | 기존 직원 정보 수정 | 관리자 |

# [조회]
등록된 직원의 목록을 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 목록 영역 | 직원 목록 테이블 | • ID/이름/그룹/상태 확인<br>• 더블클릭으로 상세 정보 확인 |
| 검색 영역 | 검색 조건 및 필터 | • 계정 상태별 필터링<br>• 로그인 ID별 필터링<br>• 그룹별 필터링 |
| 버튼 영역 | 등록 버튼 | • 신규 직원 등록 |

![직원 목록](/assets/images/guide/employee/list.png)

# [등록/수정]
직원을 신규 등록하거나 기존 직원의 상세 정보를 수정할 수 있습니다.

> ⚠️ **주의사항**
> - ID는 등록 후 변경할 수 없습니다.
> - 비밀번호는 암호화되어 저장됩니다.
> - 삭제된 계정의 상세 내용은 확인할 수 없습니다

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 계정 정보 | • 로그인 ID<br>• 이름<br>• 비밀번호<br>• 사용자 ID | • 로그인 시 사용할 ID 입력<br>• 직원 이름 입력<br>• 로그인 비밀번호 설정<br>• 사용자 ID 입력 |
| 권한 설정 | • 그룹<br>• 계정 상태 | • 소속될 그룹 선택<br>• 계정 활성화 상태 설정 |

![직원 등록/수정](/assets/images/guide/employee/edit.png)
  `,
};

export default employeeContent;
